import { useMemo } from 'react';

import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from 'devextreme/data/data_source';

import { applyBearerAuthHeader } from './auth-token';
import { isBearerAuthMode } from './auth-mode';
import { getApiBaseUrl } from './runtime-urls';

type Params = {
  pageSize?: number;
  paginate?: boolean;
  defaultFilter?: Array<any>;
  defaultSort?: Array<any>;
};

const initialParams = {
  pageSize: 100,
  paginate: true,
  defaultFilter: undefined,
  defaultSort: undefined,
};

const $createDataSource = <T>(
  url: string,
  key: string | Array<string>,
  params: Params = initialParams,
  callBack?: (data: T[]) => void,
  group?: string,
) => {
  return new DataSource({
    filter: params.defaultFilter,
    sort: params.defaultSort,
    group: group,
    store: createStore({
      key: key,
      //group: group ? group : null,
      loadUrl: `${getApiBaseUrl()}${url}`,
      onBeforeSend: (method, ajaxOptions) => {
        if (isBearerAuthMode()) {
          ajaxOptions.headers ??= {};
          applyBearerAuthHeader(ajaxOptions.headers as Record<string, string | undefined>);
        } else {
          ajaxOptions.xhrFields = { withCredentials: true };
        }
      },
      //loadMode: 'raw',
      updateUrl: `${getApiBaseUrl()}${url}`,
      onLoaded: (result: Array<T>) => {
        if (callBack) callBack(result);
      },
    }),
    pageSize: params.pageSize,
    paginate: params.paginate,
    onLoadError(e) {
      //@ts-ignore
      if (e.message.toString() === 'Unauthorized') {
        window.location.hash = 'logout-auth';
      }
    },
  });
};

export default $createDataSource;

export const useDataSource = <T>(
  url: string,
  key: string | Array<string>,
  params: Params = initialParams,
  callBack?: (data: T[]) => void,
  group?: string,
) => {
  const dataSource = useMemo(() => {
    return new DataSource({
      filter: params.defaultFilter,
      sort: params.defaultSort,
      group: group,
      store: createStore({
        key: key,
        //group: group ? group : null,
        loadUrl: `${getApiBaseUrl()}${url}`,
        onBeforeSend: (method, ajaxOptions) => {
          if (isBearerAuthMode()) {
            ajaxOptions.headers ??= {};
            applyBearerAuthHeader(ajaxOptions.headers as Record<string, string | undefined>);
          } else {
            ajaxOptions.xhrFields = { withCredentials: true };
          }
        },
        //loadMode: 'raw',
        updateUrl: `${getApiBaseUrl()}${url}`,
        onLoaded: (result: Array<T>) => {
          if (callBack) callBack(result);
        },
      }),
      pageSize: params.pageSize,
      paginate: params.paginate,
      onLoadError(e) {
        //@ts-ignore
        if (e.message.toString() === 'Unauthorized') {
          window.location.hash = 'logout-auth';
        }
      },
    });
  }, [callBack, group, key, params.defaultFilter, params.defaultSort, params.pageSize, params.paginate, url]);

  return dataSource;
};
